<h2 mat-dialog-title>Tematica</h2>
<div mat-dialog-content class="dialog-center-cont">
  <app-spinner-overlay></app-spinner-overlay>

  <form [formGroup]="formTematiche">
    <div appFormContainer [larghezza]="5">
      @if (!isTematicaAziendale) {
        <mat-form-field appFormElement [larghezza]="1" [riempi]="true">
          <mat-label>Nome Breve</mat-label>
          <input matInput placeholder="Nome Breve" formControlName="nomeBreve" />
          <mat-error appFormError></mat-error>
        </mat-form-field>
      }

      <mat-form-field appFormElement [larghezza]="2" [riempi]="isTematicaAziendale ? false : true">
        <mat-label>{{ isTematicaAziendale ? 'Titolo tematica' : 'Domanda' }}</mat-label>
        <input
          matInput
          [placeholder]="isTematicaAziendale ? 'Titolo tematica' : 'Domanda'"
          formControlName="domanda"
        />
        <mat-error appFormError></mat-error>
      </mat-form-field>

      @if (!isTematicaAziendale) {
        <mat-form-field appFormElement [larghezza]="1">
          <mat-label>Ordinamento</mat-label>
          <input
            matInput
            placeholder="Ordinamento"
            formControlName="index"
            type="number"
            inputmode="numeric"
            appInputNumber
            min="0"
            max="999999999999"
            (keydown)="onKeyDown($event)"
          />
          <mat-error appFormError></mat-error>
        </mat-form-field>
      }

      <mat-form-field
        (mousedown)="$event.stopPropagation()"
        appFormElement
        [larghezza]="isTematicaAziendale ? 3 : 5"
        [riempi]="true"
      >
        <mat-label>Descrizione</mat-label>
        <textarea
          matInput
          cdkTextareaAutosize
          #autosize="cdkTextareaAutosize"
          cdkAutosizeMinRows="1"
          placeholder="Descrizione"
          formControlName="descrizione"
          rows="1"
        ></textarea>
        <mat-error appFormError></mat-error>
      </mat-form-field>
    </div>
    <div style="height: 10px"></div>
    <!-- TABBE -->
    <!-- TAB DOVE CI SONO GLI AMBITI -->
    <mat-tab-group #tab (selectedTabChange)="onTabChange($event)">
      <ng-container>
        <mat-tab label="Generali">
          <!-- CONTENUTO DELLA TAB -->
          <div style="height: 20px"></div>

          <div appFormContainer [larghezza]="8">
            <mat-form-field appFormElement [larghezza]="3" [riempi]="true">
              <mat-label>Ambiti</mat-label>
              <mat-select formControlName="idsAmbiti" placeholder="Ambiti" multiple>
                <mat-option
                  *ngFor="let amb of arrayAmbiti"
                  [value]="amb.id"
                  [matTooltip]="amb.descrizione"
                  matTooltipPosition="left"
                >
                  {{ amb.nomeBreve }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            @if (!isTematicaAziendale) {
              <div
                appFormElement
                [larghezza]="3"
                [riempi]="true"
                style="display: flex; align-items: baseline; column-gap: 5px"
              >
                <mat-form-field style="width: 100%">
                  <mat-label>Area</mat-label>
                  <!-- DA GESTIRE QUESTE -->
                  <mat-select
                    formControlName="aree"
                    placeholder="Area"
                    multiple
                    (selectionChange)="onSelectionChangeAree($event)"
                  >
                    <mat-option
                      *ngFor="let are of arrayAree"
                      [disabled]="
                        formTematiche.get('aree')?.value?.includes('survey') &&
                        are.chiave === 'bilanci'
                      "
                      [value]="are.chiave"
                      >{{ are.descrizione }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>

                <div *ngIf="areaSelezionata" [@fadeInOut]>
                  <ng-template #tooltip>
                    <div class="descrizione-tooltip">
                      Una volta selezionata l'area di
                      <span style="font-weight: bold">Materialità</span>, viene automaticamente
                      selezionata anche l'area
                      <span style="font-weight: bold">Sintesi/Bilancio</span>.
                    </div>
                  </ng-template>

                  <div *mytooltip="tooltip; posizione: 'bottom'; offset: 45">
                    <mat-icon style="color: var(--mat-color-accent)"> info </mat-icon>
                  </div>
                </div>
              </div>
            }

            @if (!isTematicaAziendale) {
              <!-- CONFIGURAZIONE RISPOSTE ASSESSMENT: modalità e campi che ne dipendono -->
              <div appFormElement [larghezza]="8" [riempi]="true" class="config-risposte">
                <div class="config-risposte-titolo">Configurazione risposte assessment</div>

                <div class="config-risposte-riga">
                  <div class="modalita-tematica">
                    <mat-label class="config-risposte-label">Modalità risposte</mat-label>
                    <mat-radio-group
                      aria-label="Modalità risposte"
                      formControlName="modalita"
                      class="modalita-tematica-radio"
                    >
                      <mat-radio-button value="DUE_DILIGENCE">Due Diligence</mat-radio-button>
                      <mat-radio-button value="QUESTIONARIO">Questionario</mat-radio-button>
                    </mat-radio-group>
                  </div>

                  <mat-form-field class="config-risposte-soglia">
                    <mat-label>Livello min. risp. automatiche</mat-label>
                    <input
                      matInput
                      placeholder="(Solo autovalutazione)"
                      formControlName="minLivelloRispostaAutomatica"
                    />
                    <mat-hint>Solo modalità Due Diligence</mat-hint>
                    <mat-error appFormError></mat-error>
                  </mat-form-field>

                  <div class="config-risposte-multiple">
                    <mat-slide-toggle
                      formControlName="multirisposta"
                      matTooltip="Abilita la possibilità di selezionare più RISPOSTE se tematica di tipo QUESTIONARIO"
                    >
                      Risposte multiple
                    </mat-slide-toggle>
                    <span class="config-risposte-hint">Solo modalità Questionario</span>
                  </div>
                </div>
              </div>

              <div appFormElement [larghezza]="4" [riempi]="true">
                <app-select-custom
                  [formControl]="stdr"
                  titolo="Standard di rendicontazione"
                ></app-select-custom>
              </div>

              <div appFormElement [larghezza]="4" [riempi]="true">
                <app-select-custom
                  [formControl]="compliance"
                  titolo="Compliance Normativi"
                ></app-select-custom>
              </div>

              <mat-form-field appFormElement [larghezza]="8">
                <mat-label>Sotto-settori</mat-label>
                <mat-chip-grid #chipGrid aria-label="Selezione sotto-settori">
                  <mat-chip-row
                    *ngFor="let sottoSetSel of formTematiche.get('sottoSettori')?.value || []"
                    (removed)="rimuoviSottoSettore(sottoSetSel)"
                  >
                    <span *ngIf="sottoSetSel.id"
                      >{{ settoriPerIdSottosettore[sottoSetSel.id]?.titolo }}/</span
                    >{{ sottoSetSel.titolo }}
                    <button matChipRemove [attr.aria-label]="'remove ' + sottoSetSel.titolo">
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </mat-chip-row>
                </mat-chip-grid>
                <input
                  placeholder="Ricerca sottoSettori"
                  #inputSottoSettori
                  [formControl]="formControlChipSottoSettori"
                  [matChipInputFor]="chipGrid"
                  [matAutocomplete]="auto"
                  placeholder="Scrivi per cercare i sotto-settori..."
                />
                <mat-autocomplete
                  #auto="matAutocomplete"
                  (optionSelected)="selezionaSottoSettore($event)"
                  placeholder="Sotto-settori"
                  multiple
                  [compareWith]="compareById"
                >
                  <mat-optgroup
                    *ngFor="let settore of sottoSettoriFiltrati | async"
                    [label]="settore.titolo"
                  >
                    <mat-option
                      *ngFor="let sottoSettore of settore.sottoSettori"
                      [value]="sottoSettore"
                    >
                      {{ sottoSettore.titolo }}
                    </mat-option>
                  </mat-optgroup>
                </mat-autocomplete>
              </mat-form-field>
            }

            <mat-form-field appFormElement [larghezza]="8">
              <mat-label>Obiettivi di Sviluppo Sostenibile</mat-label>
              <mat-select
                formControlName="sdgs"
                placeholder="Obiettivi di Sviluppo Sostenibile"
                multiple
                [compareWith]="compareByChiave"
              >
                <mat-option *ngFor="let sdgs of arraySdgs" [value]="sdgs">
                  {{ sdgs.valore }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            @if ((this.formTematiche.get('note')?.value || mostraNote) && !isTematicaAziendale) {
              <mat-form-field appFormElement [larghezza]="8">
                <mat-label>Note per il compilatore</mat-label>
                <textarea
                  matInput
                  placeholder="Note per il compilatore"
                  formControlName="note"
                  rows="4"
                ></textarea>
                <mat-error appFormError></mat-error>
              </mat-form-field>
            }
            @if (!this.formTematiche.get('note')?.value && !isTematicaAziendale) {
              <button mat-stroked-button class="bottone-note-compilatore" (click)="mostraNoteFn()">
                <mat-icon class="material-icons-outlined"> add</mat-icon>
                {{ mostraNote ? 'Nascondi' : 'Assegna' }} note per il compilatore
              </button>
            }
          </div>
        </mat-tab>
        @if (!isTematicaAziendale) {
          <mat-tab
            label="Risposte"
            *ngIf="
              this.formTematiche.get('aree')?.value?.length &&
              this.formTematiche.get('aree')?.value?.includes('autovalutazioni')
            "
          >
            <ng-container
              [ngTemplateOutlet]="tabRisposte"
              [ngTemplateOutletContext]="{ tabForm: 'opzioni', isVsme: false }"
            ></ng-container>
          </mat-tab>

          <mat-tab label="VSME" *ngIf="isVsme()">
            <ng-container
              [ngTemplateOutlet]="tabRisposte"
              [ngTemplateOutletContext]="{ tabForm: 'risposteVsme', isVsme: true }"
            ></ng-container>
          </mat-tab>
          <!-- ---------------------------------------- I M P A T T I ------------------------- -->
          <mat-tab
            label="Impatti"
            *ngIf="
              this.formTematiche.get('aree')?.value?.length &&
              this.formTematiche.get('aree')?.value?.includes('survey')
            "
          >
            <div style="height: 20px"></div>
            <div appFormContainer [larghezza]="2">
              <div appFormElement [larghezza]="1" [riempi]="true" class="list-container">
                <div class="cont-titolo">
                  <mat-label class="titolo">Impatti Selezionati</mat-label>
                  <div>
                    <button
                      mat-flat-button
                      class="imp-esclud"
                      color="accent"
                      (click)="apriFiltroSelezionati('impatti')"
                      matBadgeColor="warn"
                    >
                      <mat-icon matSuffix>filter_list</mat-icon>
                      Filtri
                    </button>
                  </div>
                </div>
                <div
                  cdkDropList
                  #selList="cdkDropList"
                  [cdkDropListData]="arrayImpattiSel"
                  [cdkDropListConnectedTo]="[dispList]"
                  class="list"
                  (cdkDropListDropped)="dropImpatti($event)"
                >
                  <div
                    class="box-sel"
                    *ngFor="let sel of arrayImpattiSelFiltrati"
                    cdkDrag
                    [matTooltip]="sel.descrizione"
                  >
                    <div class="box-sx">
                      <button mat-icon-button title="Sposta" aria-label="Sposta">
                        <mat-icon> drag_handle </mat-icon>
                      </button>
                      <mat-label class="truncate">{{ sel.titolo }}</mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div appFormElement [larghezza]="1" [riempi]="true" class="list-container">
                <div class="cont-titolo">
                  <mat-label class="titolo">Impatti Disponibili</mat-label>
                  <div>
                    <button
                      mat-flat-button
                      class="imp-esclud"
                      color="accent"
                      (click)="apriFiltro('impatti')"
                      matBadgeColor="warn"
                    >
                      <mat-icon matSuffix>filter_list</mat-icon>
                      Filtri
                    </button>
                  </div>
                </div>
                <div
                  cdkDropList
                  #dispList="cdkDropList"
                  [cdkDropListData]="arrayImpattiDisponibili"
                  [cdkDropListConnectedTo]="[selList]"
                  class="list"
                  (cdkDropListDropped)="dropImpatti($event)"
                >
                  <div class="loading-elementi" *ngIf="loadingImpDisp">
                    <mat-spinner style="height: 50px"></mat-spinner>
                  </div>

                  <div
                    class="loading-elementi"
                    *ngIf="!arrayImpattiDisponibili?.length && !loadingImpDisp"
                  >
                    <p>Nessun Impatto Disponibile</p>
                  </div>

                  <div
                    class="box"
                    *ngFor="let disp of arrayImpattiDisponibili"
                    cdkDrag
                    [matTooltip]="disp.descrizione"
                  >
                    <div class="box-sx">
                      <button mat-icon-button title="Sposta" aria-label="Sposta">
                        <mat-icon> drag_handle </mat-icon>
                      </button>
                      <mat-label class="truncate">{{ disp.titolo }}</mat-label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>
          <!-- ---------------------------------------- I M P E G N I  ------------------------- -->
          <mat-tab
            label="Impegni"
            *ngIf="
              this.formTematiche.get('aree')?.value?.length &&
              this.formTematiche.get('aree')?.value?.includes('bilanci')
            "
          >
            <div style="height: 20px"></div>

            <div appFormContainer [larghezza]="2">
              <div appFormElement [larghezza]="1" [riempi]="true" class="list-container">
                <div class="cont-titolo">
                  <mat-label class="titolo">Impegni Selezionati</mat-label>
                  <div>
                    <button
                      mat-flat-button
                      class="imp-esclud"
                      color="accent"
                      (click)="apriFiltroSelezionati('impegni')"
                      matBadgeColor="warn"
                    >
                      <mat-icon matSuffix>filter_list</mat-icon>
                      Filtri
                    </button>
                  </div>
                </div>
                <div
                  cdkDropList
                  #selListImpe="cdkDropList"
                  [cdkDropListData]="arrayImpegniSel"
                  [cdkDropListConnectedTo]="[dispListImpegni]"
                  class="list"
                  (cdkDropListDropped)="dropImpegni($event)"
                >
                  <div
                    class="box-sel"
                    *ngFor="let sel of arrayImpegniSelFiltrati"
                    cdkDrag
                    [matTooltip]="sel.descrizione"
                  >
                    <div class="box-sx">
                      <button mat-icon-button title="Sposta" aria-label="Sposta">
                        <mat-icon> drag_handle </mat-icon>
                      </button>
                      <mat-label class="truncate">{{ sel.titolo }}</mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div appFormElement [larghezza]="1" [riempi]="true" class="list-container">
                <div class="cont-titolo">
                  <mat-label class="titolo">Impegni Disponibili</mat-label>
                  <div>
                    <button
                      mat-flat-button
                      class="imp-esclud"
                      color="accent"
                      (click)="apriFiltro('impegni')"
                      matBadgeColor="warn"
                    >
                      <mat-icon matSuffix>filter_list</mat-icon>
                      Filtri
                    </button>
                  </div>
                </div>
                <div
                  cdkDropList
                  #dispListImpegni="cdkDropList"
                  [cdkDropListData]="arrayImpegni"
                  [cdkDropListConnectedTo]="[selListImpe]"
                  class="list"
                  (cdkDropListDropped)="dropImpegni($event)"
                >
                  <div class="loading-elementi" *ngIf="loadingImpDisp">
                    <mat-spinner style="height: 50px"></mat-spinner>
                  </div>

                  <div class="loading-elementi" *ngIf="!arrayImpegni?.length && !loadingImpDisp">
                    <p>Nessun Impegno Disponibile</p>
                  </div>

                  <div
                    class="box"
                    *ngFor="let disp of arrayImpegni"
                    cdkDrag
                    [matTooltip]="disp.descrizione"
                  >
                    <div class="box-sx">
                      <button mat-icon-button title="Sposta" aria-label="Sposta">
                        <mat-icon> drag_handle </mat-icon>
                      </button>
                      <mat-label class="truncate">{{ disp.titolo }}</mat-label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>
          <!-- ---------------------------------------- B U O N E  P R A T I C H E  ------------------------- -->
          <mat-tab
            label="Buone Pratiche"
            *ngIf="
              this.formTematiche.get('aree')?.value?.length &&
              this.formTematiche.get('aree')?.value?.includes('bilanci')
            "
          >
            <div style="height: 20px"></div>

            <div appFormContainer [larghezza]="2">
              <div appFormElement [larghezza]="1" [riempi]="true" class="list-container">
                <div class="cont-titolo">
                  <mat-label class="titolo">Buone Pratiche Selezionate</mat-label>
                  <div>
                    <button
                      mat-flat-button
                      class="imp-esclud"
                      color="accent"
                      (click)="apriFiltroSelezionati('azioni')"
                      matBadgeColor="warn"
                    >
                      <mat-icon matSuffix>filter_list</mat-icon>
                      Filtri
                    </button>
                  </div>
                </div>
                <div
                  cdkDropList
                  #selListAzioni="cdkDropList"
                  [cdkDropListData]="arrayAzioneBPSel"
                  [cdkDropListConnectedTo]="[dispListAzioniBP]"
                  class="list"
                  (cdkDropListDropped)="dropAzioneBP($event)"
                >
                  <div
                    class="box-sel"
                    *ngFor="let sel of arrayAzioneBPSelFiltrati"
                    cdkDrag
                    [matTooltip]="sel.descrizione"
                  >
                    <div class="box-sx">
                      <button mat-icon-button title="Sposta" aria-label="Sposta">
                        <mat-icon> drag_handle </mat-icon>
                      </button>
                      <mat-label class="truncate">{{ sel.titolo }}</mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div appFormElement [larghezza]="1" [riempi]="true" class="list-container">
                <div class="cont-titolo">
                  <mat-label class="titolo">Buone Pratiche Disponibili</mat-label>
                  <div>
                    <button
                      mat-flat-button
                      class="imp-esclud"
                      color="accent"
                      (click)="apriFiltro('azioniBP')"
                      matBadgeColor="warn"
                    >
                      <mat-icon matSuffix>filter_list</mat-icon>
                      Filtri
                    </button>
                  </div>
                </div>
                <div
                  cdkDropList
                  #dispListAzioniBP="cdkDropList"
                  [cdkDropListData]="arrayAzioneBP"
                  [cdkDropListConnectedTo]="[selListAzioni]"
                  class="list"
                  (cdkDropListDropped)="dropAzioneBP($event)"
                >
                  <div class="loading-elementi" *ngIf="loadingImpDisp">
                    <mat-spinner style="height: 50px"></mat-spinner>
                  </div>

                  <div class="loading-elementi" *ngIf="!arrayAzioneBP?.length && !loadingImpDisp">
                    <p>Nessun azione o buona pratica Disponibile</p>
                  </div>

                  <div
                    class="box"
                    *ngFor="let disp of arrayAzioneBP"
                    cdkDrag
                    [matTooltip]="disp.descrizione"
                  >
                    <div class="box-sx">
                      <button mat-icon-button title="Sposta" aria-label="Sposta">
                        <mat-icon> drag_handle </mat-icon>
                      </button>
                      <mat-label class="truncate">{{ disp.titolo }}</mat-label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>
          <!-- ---------------------------------------- K P I  ------------------------- -->
          <mat-tab
            label="KPI"
            *ngIf="
              this.formTematiche.get('aree')?.value?.length &&
              this.formTematiche.get('aree')?.value?.includes('bilanci')
            "
          >
            <div style="height: 20px"></div>

            <div appFormContainer [larghezza]="2">
              <div appFormElement [larghezza]="1" [riempi]="true" class="list-container">
                <div class="cont-titolo">
                  <mat-label class="titolo">KPI Selezionati</mat-label>
                  <div>
                    <button
                      mat-flat-button
                      class="imp-esclud"
                      color="accent"
                      (click)="apriFiltroSelezionati('kpi')"
                      matBadgeColor="warn"
                    >
                      <mat-icon matSuffix>filter_list</mat-icon>
                      Filtri
                    </button>
                  </div>
                </div>
                <div
                  cdkDropList
                  #selListKpi="cdkDropList"
                  [cdkDropListData]="arrayKpiSel"
                  [cdkDropListConnectedTo]="[dispListKpi]"
                  class="list"
                  (cdkDropListDropped)="dropKpi($event)"
                >
                  <div
                    class="box-sel"
                    *ngFor="let sel of arrayKpiSelFiltrati"
                    cdkDrag
                    [matTooltip]="sel.descrizione"
                  >
                    <div class="box-sx">
                      <button mat-icon-button title="Sposta" aria-label="Sposta">
                        <mat-icon> drag_handle </mat-icon>
                      </button>
                      <mat-label class="truncate">{{ sel.descrizione }}</mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div appFormElement [larghezza]="1" [riempi]="true" class="list-container">
                <div class="cont-titolo">
                  <mat-label class="titolo">KPI Disponibili</mat-label>
                  <div>
                    <button
                      mat-flat-button
                      class="imp-esclud"
                      color="accent"
                      (click)="apriFiltro('kpi')"
                      matBadgeColor="warn"
                    >
                      <mat-icon matSuffix>filter_list</mat-icon>
                      Filtri
                    </button>
                  </div>
                </div>
                <div
                  cdkDropList
                  #dispListKpi="cdkDropList"
                  [cdkDropListData]="arrayKpi"
                  [cdkDropListConnectedTo]="[selListKpi]"
                  class="list"
                  (cdkDropListDropped)="dropKpi($event)"
                >
                  <div class="loading-elementi" *ngIf="loadingImpDisp">
                    <mat-spinner style="height: 50px"></mat-spinner>
                  </div>

                  <div class="loading-elementi" *ngIf="!arrayKpi?.length && !loadingImpDisp">
                    <p>Nessun KPI Disponibile</p>
                  </div>

                  <div
                    class="box"
                    *ngFor="let disp of arrayKpi"
                    cdkDrag
                    [matTooltip]="disp.descrizione"
                  >
                    <div class="box-sx">
                      <button mat-icon-button title="Sposta" aria-label="Sposta">
                        <mat-icon> drag_handle </mat-icon>
                      </button>
                      <mat-label class="truncate">{{ disp.descrizione }}</mat-label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>
          <!-- ----------------------------------------- C E R T I F I C A Z I O N I-------------------------- -->
          <mat-tab label="Certificazioni">
            <div style="height: 20px"></div>

            <div appFormContainer [larghezza]="2">
              <div appFormElement [larghezza]="1" [riempi]="true" class="list-container">
                <div class="cont-titolo">
                  <mat-label class="titolo">Certificazioni Selezionati</mat-label>
                  <div>
                    <button
                      mat-flat-button
                      class="imp-esclud"
                      color="accent"
                      (click)="apriFiltroSelezionati('certificazioni')"
                      matBadgeColor="warn"
                    >
                      <mat-icon matSuffix>filter_list</mat-icon>
                      Filtri
                    </button>
                  </div>
                </div>
                <div
                  cdkDropList
                  #selListCertificazioni="cdkDropList"
                  [cdkDropListData]="arrayCertificazioniSel"
                  [cdkDropListConnectedTo]="[dispListCertificazioni]"
                  class="list"
                  (cdkDropListDropped)="dropCertificazioni($event)"
                >
                  <div
                    class="box-sel"
                    *ngFor="let sel of arrayCertificazioniSelFiltrati"
                    cdkDrag
                    [matTooltip]="sel.descrizione"
                  >
                    <div class="box-sx">
                      <button mat-icon-button title="Sposta" aria-label="Sposta">
                        <mat-icon> drag_handle </mat-icon>
                      </button>
                      <mat-label class="truncate">{{ sel.nomeBreve }}</mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div appFormElement [larghezza]="1" [riempi]="true" class="list-container">
                <div class="cont-titolo">
                  <mat-label class="titolo">Certificazioni Disponibili</mat-label>
                  <div>
                    <button
                      mat-flat-button
                      class="imp-esclud"
                      color="accent"
                      (click)="apriFiltro('certificazioni')"
                      matBadgeColor="warn"
                    >
                      <mat-icon matSuffix>filter_list</mat-icon>
                      Filtri
                    </button>
                  </div>
                </div>
                <div
                  cdkDropList
                  #dispListCertificazioni="cdkDropList"
                  [cdkDropListData]="arrayCertificazioni"
                  [cdkDropListConnectedTo]="[selListCertificazioni]"
                  class="list"
                  (cdkDropListDropped)="dropCertificazioni($event)"
                >
                  <div class="loading-elementi" *ngIf="loadingImpDisp">
                    <mat-spinner style="height: 50px"></mat-spinner>
                  </div>

                  <div
                    class="loading-elementi"
                    *ngIf="!arrayCertificazioni?.length && !loadingImpDisp"
                  >
                    <p>Nessuna Certificazione Disponibile</p>
                  </div>

                  <div
                    class="box"
                    *ngFor="let disp of arrayCertificazioni"
                    cdkDrag
                    [matTooltip]="disp.descrizione"
                  >
                    <div class="box-sx">
                      <button mat-icon-button title="Sposta" aria-label="Sposta">
                        <mat-icon> drag_handle </mat-icon>
                      </button>
                      <mat-label class="truncate">{{ disp.nomeBreve }}</mat-label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>
          <!-- ----------------------------------------- O b i e t t i v i -------------------------- -->

          <mat-tab
            label="Obiettivi"
            *ngIf="
              this.formTematiche.get('aree')?.value?.length &&
              this.formTematiche.get('aree')?.value?.includes('piano')
            "
          >
            <div style="height: 20px"></div>

            <div appFormContainer [larghezza]="2">
              <div appFormElement [larghezza]="1" [riempi]="true" class="list-container">
                <div class="cont-titolo">
                  <mat-label class="titolo">Obiettivi Selezionati</mat-label>
                  <div>
                    <button
                      mat-flat-button
                      class="imp-esclud"
                      color="accent"
                      (click)="apriFiltroSelezionati('obiettivi')"
                      matBadgeColor="warn"
                    >
                      <mat-icon matSuffix>filter_list</mat-icon>
                      Filtri
                    </button>
                  </div>
                </div>
                <div
                  cdkDropList
                  #selListObiettivi="cdkDropList"
                  [cdkDropListData]="arrayObiettiviSel"
                  [cdkDropListConnectedTo]="[dispListObiettivi]"
                  class="list"
                  (cdkDropListDropped)="dropObiettivi($event)"
                >
                  <div
                    class="box-sel"
                    *ngFor="let sel of arrayObiettiviSelFiltrati"
                    cdkDrag
                    [matTooltip]="sel.descrizione"
                  >
                    <div class="box-sx">
                      <button mat-icon-button title="Sposta" aria-label="Sposta">
                        <mat-icon> drag_handle </mat-icon>
                      </button>
                      <mat-label class="truncate">{{ sel.titolo }}</mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div appFormElement [larghezza]="1" [riempi]="true" class="list-container">
                <div class="cont-titolo">
                  <mat-label class="titolo">Obiettivi Disponibili</mat-label>
                  <div>
                    <button
                      mat-flat-button
                      class="imp-esclud"
                      color="accent"
                      (click)="apriFiltro('obiettivi')"
                      matBadgeColor="warn"
                    >
                      <mat-icon matSuffix>filter_list</mat-icon>
                      Filtri
                    </button>
                  </div>
                </div>
                <div
                  cdkDropList
                  #dispListObiettivi="cdkDropList"
                  [cdkDropListData]="arrayObiettivi"
                  [cdkDropListConnectedTo]="[selListObiettivi]"
                  class="list"
                  (cdkDropListDropped)="dropObiettivi($event)"
                >
                  <div class="loading-elementi" *ngIf="loadingImpDisp">
                    <mat-spinner style="height: 50px"></mat-spinner>
                  </div>

                  <div class="loading-elementi" *ngIf="!arrayObiettivi?.length && !loadingImpDisp">
                    <p>Nessun Obiettivo Disponibile</p>
                  </div>

                  <div
                    class="box"
                    *ngFor="let disp of arrayObiettivi"
                    cdkDrag
                    [matTooltip]="disp.descrizione"
                  >
                    <div class="box-sx">
                      <button mat-icon-button title="Sposta" aria-label="Sposta">
                        <mat-icon> drag_handle </mat-icon>
                      </button>
                      <mat-label class="truncate">{{ disp.titolo }}</mat-label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>
          <!-- ----------------------------------------- E S R S  -------------------------- -->
          @if (
            this.formTematiche.get('aree')?.value?.length &&
            this.formTematiche.get('aree')?.value?.includes('doppiamaterialita')
          ) {
            <mat-tab label="ESRS">
              <div style="height: 20px"></div>

              <div appFormContainer [larghezza]="2">
                <div appFormElement [larghezza]="1" [riempi]="true" class="list-container">
                  <div class="cont-titolo">
                    <mat-label class="titolo">Temi Selezionati</mat-label>
                    <div>
                      <button
                        mat-flat-button
                        class="imp-esclud"
                        color="accent"
                        (click)="apriFiltroSelezionati('esrs')"
                        matBadgeColor="warn"
                      >
                        <mat-icon matSuffix>filter_list</mat-icon>
                        Filtri
                      </button>
                    </div>
                  </div>
                  <div
                    cdkDropList
                    #selListEsrs="cdkDropList"
                    [cdkDropListData]="arrayEsrsSel"
                    [cdkDropListConnectedTo]="[dispListEsrs]"
                    class="list"
                    (cdkDropListDropped)="dropEsrs($event, true)"
                  >
                    <div
                      class="box-sel"
                      *ngFor="let sel of arrayEsrsSelFiltrati"
                      cdkDrag
                      [matTooltip]="sel.descrizione"
                    >
                      <div class="box-sx">
                        <button mat-icon-button title="Sposta" aria-label="Sposta">
                          <mat-icon> drag_handle </mat-icon>
                        </button>
                        <mat-label class="truncate">{{ sel.nomeBreve }}</mat-label>
                      </div>

                      <!-- MODIFICA CHECK ESRS -->
                      <button
                        mat-icon-button
                        style="transform: scale(0.9)"
                        (click)="$event.stopPropagation(); _openDialogCheckEsrs(sel)"
                      >
                        <mat-icon class="icone-label-chack">edit</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
                <div appFormElement [larghezza]="1" [riempi]="true" class="list-container">
                  <div class="cont-titolo">
                    <mat-label class="titolo">Temi Disponibili</mat-label>
                    <div>
                      <button
                        mat-flat-button
                        class="imp-esclud"
                        color="accent"
                        (click)="apriFiltro('esrs')"
                        matBadgeColor="warn"
                      >
                        <mat-icon matSuffix>filter_list</mat-icon>
                        Filtri
                      </button>
                    </div>
                  </div>
                  <div
                    cdkDropList
                    #dispListEsrs="cdkDropList"
                    [cdkDropListData]="arrayEsrs"
                    [cdkDropListConnectedTo]="[selListEsrs]"
                    class="list"
                    (cdkDropListDropped)="dropEsrs($event)"
                  >
                    <div class="loading-elementi" *ngIf="loadingImpDisp">
                      <mat-spinner style="height: 50px"></mat-spinner>
                    </div>

                    <div class="loading-elementi" *ngIf="!arrayEsrs?.length && !loadingImpDisp">
                      <p>Nessun Tema Disponibile</p>
                    </div>

                    <div
                      class="box"
                      *ngFor="let disp of arrayEsrs"
                      cdkDrag
                      [matTooltip]="disp.descrizione"
                    >
                      <div class="box-sx">
                        <button mat-icon-button title="Sposta" aria-label="Sposta">
                          <mat-icon> drag_handle </mat-icon>
                        </button>
                        <mat-label class="truncate">{{ disp.nomeBreve }}</mat-label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </mat-tab>
          }
        }
      </ng-container>
    </mat-tab-group>
  </form>
  <div style="height: 10px"></div>
</div>
<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-flat-button color="accent" class="accent-button" (click)="closeDialog()">
      Chiudi
    </button>
  </div>
  <div>
    <button mat-flat-button color="primary" (click)="salva()" class="primary-button">Salva</button>
  </div>
  @if (!isTematicaAziendale) {
    <div>
      <button mat-flat-button (click)="ctrOpenPromptAI()" class="ai-button">
        <mat-icon>auto_awesome</mat-icon>Prompt AI
      </button>
    </div>
  }
  @if (isTabVsme()) {
    <div class="cnt-imp-exp-btn">
      <!--    <button
        mat-flat-button
        color="accent"
        class="accent-button btn-import"
        (click)="importTabVsme()"
      >
        Importa
        <mat-icon> file_upload </mat-icon>
      </button> -->
      <button
        mat-flat-button
        style="margin-left: 0px"
        color="accent"
        class="accent-button btn-export"
        (click)="exportTabVsme()"
      >
        Esporta
        <mat-icon> file_download </mat-icon>
      </button>
    </div>
  }
</div>

<!-- TEMPLATE TAB RISPOSTE  tabForm = opzioni || risposteVsme -->
<ng-template #tabRisposte let-tabForm="tabForm" let-isVsme="isVsme">
  <mat-accordion>
    <div cdkDropList (cdkDropListDropped)="drop($event, tabForm)">
      <mat-expansion-panel
        [expanded]="espandi"
        (opened)="ctrBottoni($any(rispArr.get('sottoOpzioni')?.value))"
        *ngFor="let rispArr of $any(formTematiche.get(tabForm))?.controls; let idx = index"
        cdkDrag
      >
        <div class="" *cdkDragPlaceholder></div>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <button mat-icon-button title="Sposta" aria-label="Sposta">
              <mat-icon> drag_handle </mat-icon>
            </button>
            {{ idx + 1 }}
          </mat-panel-title>
          <mat-panel-description>
            <div class="testo-risposta">
              {{ rispArr.get('valore').value }}
            </div>

            @if (!isVsme) {
              <div class="punteggio-risposte">
                Punteggio:
                <strong>
                  {{
                    rispArr.get('punteggio').value == null ||
                    rispArr.get('punteggio').value == undefined
                      ? 'NC'
                      : rispArr.get('punteggio').value
                  }}</strong
                >
              </div>
            }

            @if (isVsme) {
              <div class="button-with-badge">
                <button
                  class="custom-button"
                  (click)="
                    apriBottomSheetNorma(
                      rispArr.get('codiceNormaVsme'),
                      rispArr.get('descrizioneNormaVsme'),
                      rispArr.get('valore').value
                    );
                    $event.stopPropagation()
                  "
                >
                  Norma
                </button>
                @if (
                  rispArr.get('codiceNormaVsme').value || rispArr.get('descrizioneNormaVsme').value
                ) {
                  <div class="badge">✔</div>
                }
              </div>
            }

            <button
              mat-icon-button
              title="Elimina"
              aria-label="Elimina"
              color="warn"
              (click)="elimina($any(formTematiche.get(tabForm)), idx)"
            >
              <mat-icon>delete</mat-icon>
            </button>

            @if (isVsme) {
              <div [formGroup]="rispArr">
                <section>
                  <mat-checkbox
                    [checked]="isAllChecked(rispArr)"
                    (change)="updateAllChild($event.checked, rispArr)"
                    (click)="$event.stopPropagation()"
                    [formControlName]="'moduloCompleto'"
                    >Modulo Completo</mat-checkbox
                  >
                </section>
              </div>
            }
          </mat-panel-description>
        </mat-expansion-panel-header>
        <!--form opzioni -->
        <div appFormContainer [larghezza]="4" [formGroup]="rispArr">
          <mat-form-field
            (mousedown)="$event.stopPropagation()"
            appFormElement
            [larghezza]="2"
            [riempi]="true"
          >
            <mat-label>Risposta</mat-label>
            <textarea
              #inputDesc
              matInput
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="1"
              placeholder="Risposta"
              formControlName="valore"
              rows="1"
            ></textarea>
            <mat-error appFormError></mat-error>
          </mat-form-field>

          @if (isVsme) {
            <mat-form-field
              (mousedown)="$event.stopPropagation()"
              appFormElement
              [larghezza]="4"
              [riempi]="true"
            >
              <mat-label>Descrizione</mat-label>
              <textarea
                #inputDesc
                matInput
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                placeholder="Descrizione"
                formControlName="descrizione"
                rows="1"
              ></textarea>
              <mat-error appFormError></mat-error>
            </mat-form-field>
          }
          @if (!isVsme) {
            <mat-form-field
              (mousedown)="$event.stopPropagation()"
              appFormElement
              [larghezza]="1"
              [riempi]="true"
            >
              <mat-label>Punteggio</mat-label>
              <input
                #inputPunt
                matInput
                placeholder="Punteggio"
                type="number"
                appInputNumber
                formControlName="punteggio"
              />
              <mat-error appFormError></mat-error>
            </mat-form-field>

            <section
              class="check-nc"
              (mousedown)="$event.stopPropagation()"
              appFormElement
              [minWidth]="'auto'"
              [larghezza]="0"
            >
              <mat-checkbox formControlName="nc" (change)="cambioNc($event, idx)">NC</mat-checkbox>
            </section>
          }

          <div appFormElement [larghezza]="3" [riempi]="true" class="separatore-sottorisposte">
            <app-separatore-label
              class="separatore-sottorisposte-label"
              titoloSeparatore="Sottorisposte"
              [styleSeparatore]="'small'"
            ></app-separatore-label>
            @if (!isVsme && $any(rispArr.get('sottoOpzioni'))?.length) {
              <mat-slide-toggle
                matTooltip="Abilita la possibilità di selezionare più SOTTORISPOSTE se tematica di tipo QUESTIONARIO"
                formControlName="multirisposta"
                (mousedown)="$event.stopPropagation()"
              >
                Sottorisposte multiple
              </mat-slide-toggle>
            }
          </div>
          <!-- END appFormContainer -->
        </div>

        <div style="height: 25px"></div>

        <!-- SOTTORISPOSTE -->
        <mat-accordion appFormElement [larghezza]="3">
          <div cdkDropList (cdkDropListDropped)="dropSotto($event, rispArr.get('sottoOpzioni'))">
            <mat-expansion-panel
              [expanded]="false"
              #panel
              [hideToggle]="sottoRisp.get('tipo').value === 'dynamic_table'"
              (opened)="sottoRisp.get('tipo').value === 'dynamic_table' && panel.close()"
              *ngFor="
                let sottoRisp of $any(rispArr.get('sottoOpzioni'))?.controls;
                let idx2 = index
              "
              cdkDrag
            >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <button mat-icon-button title="Sposta" aria-label="Sposta">
                    <mat-icon> drag_handle </mat-icon>
                  </button>
                  <div *ngIf="sottoRisp.get('tipo').value === 'checkbox'">
                    Sottorisposta {{ idx2 + 1 }}
                  </div>
                  <div *ngIf="sottoRisp.get('tipo').value === 'kpi'">Kpi</div>
                  <div *ngIf="sottoRisp.get('tipo').value === 'azione'">Azione e Buona Pratica</div>
                  <div *ngIf="sottoRisp.get('tipo').value === 'dynamic_table'">Tabella</div>
                </mat-panel-title>
                <mat-panel-description>
                  <div *ngIf="sottoRisp.get('tipo').value === 'checkbox'" class="testo-risposta">
                    {{ sottoRisp.get('valore').value }}
                  </div>

                  <div *ngIf="sottoRisp.get('tipo').value === 'kpi'" class="testo-risposta">
                    {{ sottoRisp.get('valore').value?.descrizione }}
                  </div>

                  <div *ngIf="sottoRisp.get('tipo').value === 'azione'" class="testo-risposta">
                    {{ sottoRisp.get('valore').value?.titolo }}
                  </div>

                  @if (sottoRisp.get('tipo').value === 'dynamic_table') {
                    <div class="testo-risposta">
                      {{ sottoRisp.get('valore').value?.titoloTabella }}
                    </div>
                    <button
                      mat-icon-button
                      title="Modifica tabella"
                      aria-label="Modifica tabella"
                      color="accent"
                      (click)="
                        apriCfgTabella(
                          'azione',
                          rispArr.get('valore'),
                          $any(rispArr.get('sottoOpzioni')),
                          isVsme,
                          idx2
                        )
                      "
                    >
                      <mat-icon>edit</mat-icon>
                    </button>
                  }
                  <!-- PROMPT AI SOTTORISPOSTA -->
                  @if (isVsme) {
                    <button
                      class="ai-icon-button"
                      mat-icon-button
                      title="Inserimento prompt AI"
                      aria-label="Inserimento prompt AI"
                      (click)="promptAiSottoRisp(idx, idx2); $event.stopPropagation()"
                    >
                      <mat-icon>auto_awesome</mat-icon>
                    </button>
                  }

                  <!-- ELIMINAZIONE SOTTO RISPOSTA -->
                  <button
                    mat-icon-button
                    title="Elimina Sottorisposta"
                    aria-label="Elimina Sottorisposta"
                    color="warn"
                    (click)="elimina($any(rispArr.get('sottoOpzioni')), idx2)"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>

                  <!-- CHECK MODULO COMPLETO -->
                  @if (isVsme) {
                    <form [formGroup]="sottoRisp">
                      <section>
                        <mat-checkbox
                          color="primary"
                          (click)="$event.stopPropagation()"
                          [formControlName]="'moduloCompleto'"
                          >Modulo Completo</mat-checkbox
                        >
                      </section>
                    </form>
                  }
                </mat-panel-description>
              </mat-expansion-panel-header>

              <div appFormContainer [larghezza]="3" [formGroup]="sottoRisp">
                <app-autocomplete
                  *ngIf="sottoRisp.get('tipo').value === 'kpi'"
                  appFormElement
                  [larghezza]="2"
                  [riempi]="true"
                  formControlName="valore"
                  [label]="'KPI'"
                  [loadDataFn]="getKPIAutoComplete"
                  [displayFn]="displayFn"
                  [compare]="compareById"
                  [required]="true"
                  [chiaveId]="'id'"
                >
                </app-autocomplete>

                <app-autocomplete
                  *ngIf="sottoRisp.get('tipo').value === 'azione'"
                  appFormElement
                  [larghezza]="2"
                  [riempi]="true"
                  formControlName="valore"
                  [label]="'Azioni e Buone Pratiche'"
                  [loadDataFn]="getAzioneAutoComplete"
                  [displayFn]="displayFnAzione"
                  [compare]="compareById"
                  [required]="true"
                  [chiaveId]="'id'"
                >
                </app-autocomplete>

                <mat-form-field
                  *ngIf="sottoRisp.get('tipo').value === 'checkbox'"
                  (mousedown)="$event.stopPropagation()"
                  appFormElement
                  [larghezza]="2"
                  [riempi]="true"
                >
                  <mat-label>Descrizione Sottorisposta</mat-label>
                  <input
                    matInput
                    placeholder="Descrizione Sottorisposta"
                    formControlName="valore"
                  />
                  <mat-error appFormError></mat-error>
                </mat-form-field>

                @if (!isVsme) {
                  <mat-form-field
                    *ngIf="sottoRisp.get('tipo').value === 'checkbox'"
                    (mousedown)="$event.stopPropagation()"
                    appFormElement
                    [larghezza]="1"
                    [riempi]="true"
                  >
                    <mat-label>Punteggio Sottorisposta</mat-label>
                    <input
                      matInput
                      placeholder="Punteggio Sottorisposta"
                      type="number"
                      appInputNumber
                      formControlName="punteggio"
                    />
                    <mat-error appFormError></mat-error>
                  </mat-form-field>
                  <mat-form-field
                    *ngIf="
                      sottoRisp.get('tipo').value === 'kpi' ||
                      sottoRisp.get('tipo').value === 'azione'
                    "
                    (mousedown)="$event.stopPropagation()"
                    appFormElement
                    [larghezza]="1"
                    [riempi]="true"
                  >
                    <mat-label>Punteggio se compilato</mat-label>
                    <input
                      matInput
                      placeholder="Punteggio se compilato"
                      type="number"
                      appInputNumber
                      formControlName="punteggio"
                    />
                    <mat-error appFormError></mat-error>
                  </mat-form-field>
                }
              </div>
            </mat-expansion-panel>
          </div>
        </mat-accordion>

        <div style="height: 25px"></div>

        <div style="display: flex; column-gap: 20px">
          <div *ngIf="isSottoRisp || isVsme" appFormElement [larghezza]="3" [riempi]="true">
            <button
              mat-stroked-button
              (click)="addRiga($any(rispArr.get('sottoOpzioni')), true, isVsme)"
              class="bottoni-risposte"
            >
              + Aggiungi Sottorisposte
            </button>
          </div>

          <div *ngIf="isKpi || isAzione || isVsme" appFormElement [larghezza]="3" [riempi]="true">
            <button
              mat-stroked-button
              (click)="
                apriCfgRisposte(
                  'kpi',
                  rispArr.get('valore'),
                  $any(rispArr.get('sottoOpzioni')),
                  isVsme
                )
              "
              class="bottoni-risposte"
            >
              + Aggiungi KPI
            </button>
          </div>
          <div *ngIf="isKpi || isAzione || isVsme" appFormElement [larghezza]="3" [riempi]="true">
            <button
              mat-stroked-button
              (click)="
                apriCfgRisposte(
                  'azione',
                  rispArr.get('valore'),
                  $any(rispArr.get('sottoOpzioni')),
                  isVsme
                )
              "
              class="bottoni-risposte"
            >
              + Aggiungi Azione e Buona pratica
            </button>
          </div>
          <div *ngIf="isVsme" appFormElement [larghezza]="3" [riempi]="true">
            <button
              mat-stroked-button
              (click)="
                apriCfgTabella(
                  'azione',
                  rispArr.get('valore'),
                  $any(rispArr.get('sottoOpzioni')),
                  isVsme
                )
              "
              class="bottoni-risposte"
            >
              + Aggiungi Tabella
            </button>
          </div>
        </div>
      </mat-expansion-panel>
    </div>
  </mat-accordion>

  <div style="height: 25px"></div>

  <button
    mat-stroked-button
    (click)="addRiga($any(formTematiche.get(tabForm)), false, isVsme)"
    class="bottoni-risposte"
  >
    + Aggiungi Risposta
  </button>
</ng-template>
